<template>
  <div class="detail">
    <div class="video-box">
      <video 
        :src="detail.content"
        controls="controls" 
        x5-video-player-type="h5-page" 
        x5-video-player-fullscreen="true" 
        x5-playsinline="" 
        playsinline=""
        webkit-playsinline="true"
        x5-video-orientation="landscape"
        class="video"
      ></video>
      <!-- <div class="title">{{detail.title}}</div> -->
    </div>
  </div>
</template>

<script>
export default {
  props: {
    detail: {
      type: Object,
      default() {
        return {}
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
.video {
  width: 100vw;
  height: 100vh;
}
// .detail {
//   width: 100%;
//   height: 100vh;
//   .video-box {
//     background: #000;
//     height: 100vh;
//     video {
//       width 100%
//       height 194px
//       margin-top: 190px;
//       background #000;
//       object-fit: fill
//     }
//     .title {
//       padding: 10px;
//       color: #fff;
//     }
//   }
// }
</style>